export class CmsHttpStatusCode {
  static readonly BLOCKED_BY_COOKIE_CONSENT = 499
}
